module.exports = __webpack_public_path__ + "img/icons_37.64fd8f39.svg";